import axios from 'axios'
import {
  SESSION_COOKIE_KEY,
  SUPER_ADMIN_SESSION_COOKIE_KEY,
  SessionType,
} from '@/constants/session'

export const updateSession = async (
  token: string,
  type: SessionType = SESSION_COOKIE_KEY
): Promise<string | null> => {
  // Call the API route to set or clear the session cookie
  await fetch('/api/session', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, type }),
  })

  if (token == '') {
    delete axios.defaults.headers.common['Authorization']
    return null
  }
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
  return token
}

export const deleteSession = async (type: SessionType = SESSION_COOKIE_KEY) => {
  await fetch(`/api/session?type=${type}`, { method: 'DELETE' })
  delete axios.defaults.headers.common['Authorization']
}

export const getSessionToken = async (
  type: SessionType = SESSION_COOKIE_KEY
): Promise<string | null> => {
  try {
    const { cookies } = require('next/headers')
    const cookieStore = await cookies()
    const cookieKey =
      type === SUPER_ADMIN_SESSION_COOKIE_KEY ? SUPER_ADMIN_SESSION_COOKIE_KEY : SESSION_COOKIE_KEY
    return cookieStore.get(cookieKey)?.value || null
  } catch {
    return null
  }
}
